import { Grid, Input } from '@yuno/design-system-web'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export const ConnectionFieldName = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const { t } = useTranslation()

  return (
    <Grid item xs={12} sx={{ paddingTop: '20px' }}>
      {/* @ts-ignore */}
      <Input
        id="name"
        type={'text'}
        label={t('name')}
        placeholder={t('enterName')}
        name={'name'}
        {...register('name' as never, { required: true })}
        fullWidth
        error={!!errors['name']}
        helperText={
          errors['name']?.message
            ? String(errors['name'].message)
            : errors['name']
            ? t('fillField')
            : ''
        }
      />
    </Grid>
  )
}
